import React, { useState } from 'react';
import { Button, Modal, Spin, Icon, message } from 'antd';

import { previewEmail } from '../api';

/**
 * O e-mail como saiu, a partir do relatório.
 *
 * A prévia só existia no passo de revisão do editor, e o editor fecha quando a
 * campanha é disparada — depois do envio não havia como ver o que foi mandado.
 * A rota de prévia não olha o status, então serve igual aqui.
 */
const VerEmail = ({ id }) => {
  const [aberto, setAberto] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [prev, setPrev] = useState(null);

  const abrir = () => {
    setAberto(true);
    if (prev) return;

    setCarregando(true);
    previewEmail(id)
      .then((dados) => { if (dados) setPrev(dados); })
      .catch(() => message.error('Não foi possível carregar o e-mail.'))
      .finally(() => setCarregando(false));
  };

  return (
    <>
      <Button icon="eye" style={{ borderRadius: 8 }} onClick={abrir}>Ver e-mail</Button>

      <Modal
        title="E-mail da campanha"
        visible={aberto}
        onCancel={() => setAberto(false)}
        footer={null}
        width={760}
        bodyStyle={{ padding: 16 }}
      >
        {carregando || !prev ? (
          <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>
        ) : (
          <div>
            <div style={{ border: '1px solid #e8e8e8', borderRadius: 6, overflow: 'hidden', background: '#f0f2f5' }}>
              <iframe
                title="E-mail da campanha"
                srcDoc={prev.html || ''}
                sandbox=""
                style={{ width: '100%', height: 560, border: 0, display: 'block' }}
              />
            </div>
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
              <Icon type="info-circle" />{' '}
              {prev.amostra
                ? <span>Variáveis preenchidas com os dados de <strong>{prev.amostra}</strong>; cada destinatário recebeu com os seus.</span>
                : 'Variáveis preenchidas com dados de exemplo; cada destinatário recebeu com os seus.'}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default VerEmail;
